<template lang="pug">
  v-dialog(:value='true', width='350', persistent='', no-click-animation='')
    v-card.pa-3
      h3.text-xs-center.pa-3
        img(src='/static/icon.ico', height='120')
        br
        | {{ $t('words.welcome') | capitalize }}
      v-card-text
        v-form(v-model='valid', @submit.prevent='signIn')
          v-text-field(v-model='model.email', label='E-mail', required='')
          v-text-field(v-model='model.password', label='Senha', type='password', required='')
          v-alert.my-3(:value='error', type='error')
            | {{ $t('messages.invalidEmailOrPassword') | capitalize }}
          v-btn(:loading='loading', type='submit', color='primary')
            | {{ $t('words.login') }}
</template>

<script>
import { auth } from '@/store/firebase'

export default {
  data () {
    return {
      model: {
        email: '',
        password: ''
      },
      fields: {
        username: { label: 'Username' },
        password: { label: 'Password', type: 'password' }
      },
      loading: false,
      valid: true,
      error: false
    }
  },

  watch: {
    'model.email' () {
      this.error = false
    },
    'model.password' () {
      this.error = false
    }
  },

  methods: {
    onSuccess (data) {
      console.log(data)
    },
    signIn () {
      if (!this.valid) return

      this.loading = true
      this.error = false
      const { email, password } = this.model
      auth.signInWithEmailAndPassword(email, password)
        .then((res) => {
          this.$router.push('/')
        })
        .catch((err) => {
          console.log(err)
          this.error = true
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>
  body {
    background-color: #d1d2d3;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue